module.exports = __webpack_public_path__ + "img/icon46.c56bf70e.png";